<template>
    <div class="property" :class="{loading: loading || !property, suppressed: myProperty.suppressed}">
        <div :class="{placeholder: myProperty.placeholder}" style="height: 100%; max-height: 200px;">
            <div class="image" :style="propertyImageStyle(myProperty.images)">
                <span v-if="!Array.isArray(myProperty.images) || myProperty.images.length === 0">
                    No photo available
                </span>
            </div>
            <div class="details">
                <span class="name" v-text="myProperty.name" />
                <span class="address">
                    <span class="street" v-text="myProperty.address1" />
                    <span class="town">
                        {{ myProperty.city }}, {{ myProperty.state }}
                        {{ myProperty.zip }}
                    </span>
                </span>
                <ul class="property-info">
                    <li
                        class="beds"
                        v-if="bedsTotal > 0"
                    >
                        {{ bedsTotal }} <span class="nowrap">bed{{ bedsTotal > 1 ? 's' : '' }}</span>
                    </li>
                    <li
                        class="bath_full"
                        v-if="myProperty.bath_full > 0"
                    >
                        {{ myProperty.bath_full }} <span class="nowrap">full bath{{ myProperty.bath_full > 1 ? 's' : '' }}</span>
                    </li>
                    <li
                        class="baths-half"
                        v-if="myProperty.bath_half > 0"
                    >
                        {{ myProperty.bath_half }} <span class="nowrap">half bath{{ myProperty.bath_half > 1 ? 's' : '' }}</span>
                    </li>
                </ul>
                <ul class="actions">
                    <li><a :href="'/property?id=' + myProperty.slug">
                        <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                        Details
                    </a></li>
                    <li class='toggle-hide' @click="$emit('toggle-hide')">
                        <template v-if="myProperty.suppressed">
                            <font-awesome-icon icon="fa-solid fa-eye" />
                            Show
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="fa-solid fa-eye-slash" />
                            Hide
                        </template>
                    </li>
                    <li @click="$emit('toggle-favorite')">
                        <template v-if="myProperty.favorite">
                            <font-awesome-icon icon="fa-solid fa-heart-crack" style="color: red;" />
                            Remove
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="fa-solid fa-heart" style="color: red;" />
                            Favorite
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faMagnifyingGlass, faEye, faEyeSlash, faHeart, faHeartCrack } from '@fortawesome/free-solid-svg-icons'
library.add(faMagnifyingGlass, faEye, faEyeSlash, faHeart, faHeartCrack);

export default {
    components: {
        FontAwesomeIcon,
    },
    props: {
        property: {},
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
        }
    },
    computed: {
        myProperty() {
            if (this.property) {
                return this.property;
            }
            return {
                placeholder: true,
                suppressed: false,
                favorite: false,

                address1: '123 Main Street',
                city: 'Bar Harbor',
                state: 'ME',
                zip: '04609',
                bath_full: 3,
                bath_half: 1,
            };
        },
        bedsTotal() {
            return (this.myProperty.bed_king ?? 0)
                + (this.myProperty.bed_queen ?? 0)
                + (this.myProperty.bed_full ?? 0)
                + (this.myProperty.bed_twin ?? 0)
                + (this.myProperty.bed_bunk ?? 0)
                + (this.myProperty.bed_futon ?? 0)
                + (this.myProperty.bed_sofa ?? 0)
            ;
        },
    },
    methods: {
        propertyImageStyle(photos) {
            if (!Array.isArray(photos)) {
                return '';
            }
            if (photos.length > 0) {
                return 'background-image: url(' + process.env.MIX_APP_URL + '/' + photos[0].directory + '/' + photos[0].filename + ')';
            }
            return '';
        },
    },
}
</script>

<style lang="scss">
.property {
    border: 1px solid black;
    padding: 0;
    margin: 10px;

    & > div {
        display: flex;
        column-gap: 10px;
    }

    .image {
        flex: 0 0 30vw;
        //height: 20vw;
        background-position: center center;
        background-size: cover;
        display: inline-block;
        max-height: 14em;
        max-width: 480px;
        //background-color: lighten(#003081, 70%);
        //background-color: lighten(#3cacde, 70%);
        background-color: #93bff0;
    }

    .details {
        font-size: 11pt;
        padding: 5px 10px;
        //display: inline-flex;
        //flex-wrap: wrap;
        //justify-content: space-between;
        //align-items: center;
        //overflow: hidden;
    }

    .name {
        font-size: 15pt;
    }

    .address {
        //flex: 0 0 calc(100% - 6em);
        font-size: 12pt;
    }

    //.price {
    //    flex: 0 0 6em;
    //    font-size: 12pt;
    //    font-weight: bold;
    //    text-align: right;
    //}

    .street, .town {
        display: block;
    }

    //.listing-info,
    .property-info {
        //flex: 0 0 100%;
        display: flex;
        flex-wrap: nowrap;
        column-gap: 5px;
        margin: 15px 0;
        padding: 0;
        //color: #003081;
        list-style-type: none;

        li {
            display: inline-block;
            text-align: center;
            border: 1px solid #aaa;
            border-radius: 5px;
            padding: 4px;
            font-weight: bold;
            margin: 0;
        }

        .nowrap {
            font-weight: normal;
        }

    }

    //.view, .waterfront {
    //    margin: 2px 0;
    //    flex: 0 0 100%;
    //}

    //.idx-logo-image img {
    //    max-width: 10vw;
    //}
    //
    //.listed-by {
    //    flex: 0 0 100%;
    //    font-size: 10pt;
    //    white-space: nowrap;
    //    overflow: hidden;
    //    text-overflow: ellipsis;
    //    padding: 5px 0;
    //}

    .actions {
        list-style-type: none;
        display: flex;
        //flex-direction: row;
        flex-wrap: nowrap;
        //border-radius: 5px;
        margin: 0;
        padding: 0;

        li {
            border: 1px solid #bbbbbb;
            margin: 0;
            padding: 10px;
            text-align: center;
            font-size: 10pt;
            cursor: default
        }

        li:hover {
            background-color: #eee;
        }

        a {
            color: inherit;
            text-decoration: none;
        }
    }
    .nowrap {
        white-space: nowrap;
    }

    &.loading {
        position: relative;
        overflow: hidden;
        pointer-events: none;
        opacity: 0.5;
    }
    &.loading::before {
        content: '';
        display: block;
        position: absolute;
        left: -150px;
        top: 0;
        height: 100%;
        width: 150px;
        background: linear-gradient(to right, transparent 0%, #cccccc 50%, transparent 100%);
        animation: load 1.5s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
    }
    @keyframes load {
        from {
            left: -150px;
        }
        to   {
            left: 100%;
        }
    }

    &.suppressed {
        .image, .details > *:not(.actions), .actions > *:not(.toggle-hide) {
            filter: blur(2px);
            opacity: 0.5;
        }
    }

    .placeholder {
        * {
            filter: blur(2px);
        }
        .image {
            filter: blur(4px);
            opacity: 0.8;
        }
    }
}
</style>
